import { __rest } from "tslib";
import React, { useState } from 'react';
import cn from 'classnames';
import Transition from 'react-transition-group/Transition';
import { CloseIcon } from "../../ui/Icon/HmIcons";
import IconButton from '../../ui/CTA/IconButton';
import HeadingMedium from '../../ui/Typography/titles/HeadingMedium';
import styles from './MessagePanel.module.scss';
const MessagePanel = (_a) => {
    var { title, image, children, className, onMessageClose, isClosable, closeIconSize } = _a, props = __rest(_a, ["title", "image", "children", "className", "onMessageClose", "isClosable", "closeIconSize"]);
    const [isOpen, setState] = useState(true);
    const handleCloseClick = () => {
        setState(!isOpen);
        if (onMessageClose) {
            onMessageClose();
        }
    };
    return (React.createElement(Transition, { in: isOpen, timeout: { enter: 0, exit: 300 }, unmountOnExit: true }, (transitionState) => (React.createElement("section", Object.assign({ className: cn(styles.container, image && styles.leftAlign, className, styles[transitionState]) }, props),
        image && React.createElement("div", { className: styles.imageContainer }, image),
        React.createElement("div", { className: styles.contentContainer },
            isClosable && (React.createElement(IconButton, { className: styles.closeButton, onClick: handleCloseClick, iconElement: React.createElement(CloseIcon, { size: closeIconSize }) })),
            title && React.createElement(HeadingMedium, { Tag: "h2" }, title),
            children)))));
};
export default MessagePanel;
//# sourceMappingURL=MessagePanel.js.map